export const config = {
    environment: process.env.PREACT_APP_ENVIRONMENT,
    apiUrl: process.env.PREACT_APP_API_URL,
    sharedCookiesDomain: process.env.PREACT_APP_SHARED_COOKIES_DOMAIN,
    websiteUrl: process.env.PREACT_APP_WEBSITE_URL,
    consoleUrl: process.env.PREACT_APP_CONSOLE_URL,
    extensionDownloadUrl: process.env.PREACT_APP_EXTENSION_DOWNLOAD_URL,
    widgetUrl: process.env.PREACT_APP_WIDGET_URL,
};
